module.exports = __webpack_public_path__ + "img/logoOpenClassRoomsGray.99f69d67.svg";